module.exports = __webpack_public_path__ + "static/media/vr-cardboard.2c33630f.svg";